import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'dateFormattedPipe',
})
export class DateFormattedPipe implements PipeTransform {
    transform(value: string, arg: string = '') {

		var datePipe = new DatePipe("ru-RU");
	   let format = 'dd.MM.yyyy HH:mm:ss'
 	   if( arg ){
			if(arg === 'noTime'){
				format = 'dd.MM.yyyy'
			} else if(arg === 'noSeconds') {
				format = 'dd.MM.yyyy HH:mm'
			}  
	 	}

        value = datePipe.transform(value, format);
        return value;
    }
}
